import React, { useEffect, useRef, useState } from "react";
import { useFont } from "../../contexts/FontContext/FontContext";
import styles from "./MainSection.module.css";
import Blurb from "./Blurb";

const MainSection = () => {
  const fontSchemes = useFont();
  const fontFamilyTwo = fontSchemes.scheme_two;
  const fontFamilyThree = fontSchemes.scheme_three;

  const [showDemoModal, setShowDemoModal] = useState(false);
  const [showDemoCta, setShowDemoCta] = useState(false);
  const demoCtaRef = useRef(null);

  const demoVideoSrc = `${process.env.PUBLIC_URL}/videos/return_portal_demo.mp4`;

  useEffect(() => {
    const t1 = setTimeout(() => document.querySelector(".blurb_one")?.classList.add(styles.fade_in), 250);
    const t2 = setTimeout(() => document.querySelector(".blurb_two")?.classList.add(styles.fade_in), 500);
    const t3 = setTimeout(() => document.querySelector(".blurb_three")?.classList.add(styles.fade_in), 750);

    const width = window.innerWidth;
    let observer = null;
    let t4 = null;

    if (width >= 481 && width <= 767 && demoCtaRef.current) {
      observer = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) setShowDemoCta(true); }, { threshold: 0.25 });
      observer.observe(demoCtaRef.current);
    } else {
      t4 = setTimeout(() => setShowDemoCta(true), 1200);
    }

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      if (t4) clearTimeout(t4);
      if (observer) observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const handleEscape = (e) => { if (e.key === "Escape") setShowDemoModal(false); };

    if (showDemoModal) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", handleEscape);
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
      window.removeEventListener("keydown", handleEscape);
    };
  }, [showDemoModal]);

  return (
    <>
      <div className={styles.main_section}>
        <div className={`${styles.main_section_dividers} ${styles.main_section_left_top_container}`}>
          <div className={styles.main_section_text_wrapper}>
            <h1 className={`${styles.upper_text_main_section} ${fontFamilyTwo}`}>Streamline your returns.</h1>
            <h2 className={`${styles.lower_text_main_section} ${fontFamilyThree}`}>Save your business time and money and save your customers a trip to the post office.</h2>
          </div>
          <div className={styles.endorsements_container}>
            <div className={styles.five_star_rating_container}>
              <img src={`${process.env.PUBLIC_URL}/images/5_star_rating.png`} className={styles.five_stars} alt="five_stars" />
              <p className={`${styles.five_star_blurb} ${fontFamilyTwo}`}>"Super easy!"</p>
            </div>
            <div className={styles.endorsers}>
              <img src={`${process.env.PUBLIC_URL}/images/fulton_logo.png`} className={styles.endorsement_logo} alt="fulton_logo" />
              <img src={`${process.env.PUBLIC_URL}/images/highline_commerce_logo.png`} className={styles.endorsement_logo} alt="endorsement_logo" />
            </div>
          </div>
          <div ref={demoCtaRef} className={`${styles.demo_cta_container} ${showDemoCta ? styles.fade_in : ""}`}>
            <div className={styles.demo_cta_card}>
              <div className={styles.demo_cta_text_group}>
                <p className={`${styles.demo_cta_eyebrow} ${fontFamilyThree}`}>See ShipWheel in action!</p>
                <h3 className={`${styles.demo_cta_heading} ${fontFamilyTwo}`}>Returns portal demo</h3>
                <p className={`${styles.demo_cta_subtext} ${fontFamilyThree}`}>Preview the returns flow.</p>
              </div>
              <div className={styles.demo_cta_actions}>
                <button type="button" className={styles.demo_primary_button} onClick={() => setShowDemoModal(true)}>▶ Watch</button>
              </div>
            </div>
          </div>
        </div>
        <div className={`${styles.main_section_dividers} ${styles.main_section_right_bottom_container}`}>
          <img src={`${process.env.PUBLIC_URL}/images/globe.png`} className={styles.main_section_image} alt="globe_image" />
          <Blurb id="blurb_one" text="Increase Revenue" text_two="+35%" imageOneSrc={`${process.env.PUBLIC_URL}/images/rev_arrow.png`} imageTwoSrc={`${process.env.PUBLIC_URL}/images/rev_graph.png`} imageOneId="rev_arrow" imageTwoId="rev_graph" metric="blurb_one_percent" />
          <Blurb id="blurb_two" text="Automate Logistics" text_two="100 hrs saved" imageOneSrc={`${process.env.PUBLIC_URL}/images/logistics_down_arrow.png`} imageTwoSrc={`${process.env.PUBLIC_URL}/images/clock.png`} imageOneId="logistics_down_arrow" imageTwoId="clock" metric="blurb_two_hours_saved" />
          <Blurb id="blurb_three" text="Improve Bottom Line" text_two="$10,000" imageOneSrc={`${process.env.PUBLIC_URL}/images/dollar_arrow.png`} imageTwoSrc={`${process.env.PUBLIC_URL}/images/dollars.png`} imageOneId="dollar_arrow" imageTwoId="dollars" metric="blurb_three_dollars" />
        </div>
      </div>
      {showDemoModal && (
        <div className={styles.demo_modal_overlay} onClick={() => setShowDemoModal(false)}>
          <div className={styles.demo_modal_content} onClick={(e) => e.stopPropagation()}>
            <button type="button" className={styles.demo_modal_close} onClick={() => setShowDemoModal(false)} aria-label="Close demo video">×</button>
            <div className={styles.demo_video_wrapper}>
              <video className={styles.demo_video} controls autoPlay playsInline preload="metadata"><source src={demoVideoSrc} type="video/mp4" />Your browser does not support the video tag.</video>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MainSection;